import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { UigTabParagraphContainerComponent } from './uig-tab-paragraph-container/uig-tab-paragraph-container.component';
import { OutletModule, PageComponentModule } from '@spartacus/storefront';

@NgModule({
    imports: [
        CommonModule,
        PageComponentModule,
        OutletModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CMSTabParagraphContainer: {
                    component: UigTabParagraphContainerComponent,
                },
            },
        } as CmsConfig),
    ],
    declarations: [UigTabParagraphContainerComponent],
    exports: [UigTabParagraphContainerComponent]
})
export class UigContentModule {}
